import React from "react";

function LoadignIcon() {
  return (
    <div className="Icon-container">
      <img src="/loading.gif" alt="Loading..." />
    </div>
  );
}

export default LoadignIcon;
